import { render, staticRenderFns } from "./BoxesArea.vue?vue&type=template&id=60aa5ece&"
import script from "./BoxesArea.vue?vue&type=script&lang=js&"
export * from "./BoxesArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports